import React, { useEffect } from 'react';
import './App.css';
import * as dostoy from './tools/dostoy';
import { about } from './constants/about';
import io from 'socket.io-client';

import aDrive from './handlers/adrive';

let count = 0;
let questions = [];

const socket = io(window.location.origin, {
	path: '/api/sunsh1n3/sockets/'
	// transports: ['websocket']
});

socket.on('newQuestion', (data) => {
	count++;
	questions.push(data + ' ');
});

function App() {
	useEffect(() => {
		let h = window.innerHeight;
		let canvas = document.getElementById('viewPort');
		let img = document.getElementById('banner');
		let imgH = img.clientHeight || 390;
		canvas.height = h-imgH;
		
		canvas.addEventListener('click', function(evt) {
			document.getElementById('mobileInput').focus();
		});
		canvas.addEventListener('touchstart', function(evt) {
			document.getElementById('mobileInput').focus();
		});
		dostoy.init({
			font: fontData,
			fontHeight: 14,
			canvas: canvas,
			shell: true,
			// beforeShell: function() {
			// 	// dostoy.println('Starting Sunsh1n3-DOS...');
			// 	// print(logo);
			// 	// dostoy.println();
			// 	// dostoy.println('Welcome to Sunsh1n3 of Detroit.');
			// 	// dostoy.println();
			// 	// dostoy.println();
			// 	// // dostoy.println('HIMEM is testing extended memory...done;');
			// 	// dostoy.println();
			// },
			prompt: 'C:\\>',
			commandHandler: handler
		});
	}, []);

	return (
		<div className="App">
			<main>
				<header>
					<img id="banner" src="/banner.gif" alt="Sunsh1n3 Logo"/>
				</header>
				<canvas id="viewPort" width="1024" height="768" />
				<input id="mobileInput" type="text" autoFocus={true} />
			</main>
		</div>
	);
}

export default App;

const repeat = function(text, num) {
	return new Array(num + 1).join(text);
};

const volume = {
	zork: {
		dir: true,
		time: '01-19-20  10:47p',
		folder: {
			'.': { dir: true, time: '01-19-20   10:47p' },
			'..': { dir: true, time: '01-19-20   10:47p' },
			'zork.exe': { dir: false, size: 11402, time: '06-21-96   8:41p', handler: () => {} }
		}
	},
	Sunsh1n3: {
		dir: true,
		time: '01-18-20  11:13a',
		folder: {
			'.': { dir: true, time: '01-18-20  11:13a' },
			'..': { dir: true, time: '01-18-20  11:13a' },
			'about.bat': { dir: false, size: 52, time: '01-18-20  11:13a', handler: () => {} }
		}
	},
	Positions: {
		dir: true,
		time: '02-15-20   9:30a',
		folder: {
			'.': { dir: true, time: '02-15-20   9:30a' },
			'..': { dir: true, time: '02-15-20   9:30a' },
			'fullstackdev.exe': { dir: false, size: 5221, time: '02-15-20   9:30a' },
			'gamedev.exe': { dir: false, size: 6521, time: '02-15-20   9:30a' },
			'mobiledev.exe': { dir: false, size: 7415, time: '02-15-20   9:30a' }
		}
	},
	'command.com': { dir: false, size: 54645, time: '05-31-94   6:22a', handler: () => {} },
	'autoexec.bat': { dir: false, size: 78, time: '06-18-19   9:30a', handler: () => {} }
};

let currentDir = '/';
let application = {};
let volName = 'Sunsh1n3';
let formattedC = false;

const handler = (command) => {
	let [ rootCommand, param1 ] = command.split(' ');
	rootCommand = rootCommand.split('.')[0].toLowerCase();

	switch (rootCommand) {
		case 'a':
		case 'a:':
			aDrive(dostoy);
			break;
		case 'about':
			print(about);
			break;
		case 'command':
			let txt = `Sunsh1n3 Labs Sunsh1n3-Dos Version 1.22
		Sunsh1n3 1981-2020`;
			dostoy.println();
			dostoy.println();
			print(txt);
			dostoy.println();
			break;
		case 'cls':
			dostoy.cls();
			break;
		case 'cd':
			if (formattedC === true) {
				return dostoy.println('Invalid directory');
			}
			if (param1 === '.') {
				dostoy.println();
			} else if (param1 === '..') {
				currentDir = '/';
				dostoy.setPrompt(`C:\\>`);
			} else if (param1 === '\\') {
				currentDir = '/';
				dostoy.setPrompt(`C:\\>`);
			} else if (volume[param1]) {
				currentDir = param1;
				dostoy.setPrompt(`C:\\${param1}>`);
			} else {
				dostoy.println('Invalid directory');
			}
			break;
		case 'dir':
			if (formattedC === true) {
				dostoy.println();
				dostoy.println(` Volume in drive C is ${volName}`);
				dostoy.println(' Volume Serial Number is 3116-15F1');
				dostoy.println(' Directory of C:\\');
				dostoy.println();
				dostoy.println('File not found');
				dostoy.println();
				return;
			}
			let cwd = volume[currentDir] ? volume[currentDir].folder : volume;
			if (currentDir === '/') {
				cwd = volume;
			}
			let arr = Object.keys(cwd);
			var longest = arr.sort(function(a, b) {
				return b.length - a.length;
			})[0].length;
			dostoy.println();
			Object.keys(cwd).forEach((item) => {
				let padding = new Array(longest - item.length + 1).join(' ');
				let size = numberWithCommas(cwd[item].size || '');
				let sizePadding = new Array(7 - size.length + 1).join(' ');
				dostoy.println(
					`${item}${padding}\t\t${cwd[item].dir === true ? '<DIR>' : '     '}\t${sizePadding}${size}\t${cwd[
						item
					].time}`
				);
			});
			dostoy.println();

			break;
		case 'format':
			switch (param1) {
				case 'a':
					let ready = (resp) => {
						if (resp) {
							resp = resp.charAt(0).toLowerCase();
						}
						if (resp === 'n') {
							dostoy.println();
							dostoy.println();
							dostoy.setCursor(true);
							dostoy.setPrompt('C:\\>');
							return;
						}
						dostoy.println();
						dostoy.println(`Checking existing disk format.`);
						dostoy.println(`Formatting 1.44M`);
						dostoy.println();
						dostoy.println();
						dostoy.println('Write protect error');
						dostoy.println('Format terminated.');
						dostoy.input('Format another (Y/N)', ready);
					};
					dostoy.setCursor(false);
					dostoy.setPrompt('');
					dostoy.println(`Insert new diskette for dirve A:`);
					dostoy.println('and press ENTER when ready...', ready);
					dostoy.inkey((keyCode) => {
						if (keyCode === 13) {
							ready();
						}
					});

					break;
				case 'c':
					let volumeformat = (resp = '') => {
						volName = resp;
						dostoy.println(`  523,526,144 bytes total disk space`);
						dostoy.println(`  523,526,144 bytes available on disk`);
						dostoy.println();
						dostoy.println('        8,192 bytes is each allocation unit.');
						dostoy.println('       63,907 allocation units available on disk.');
						dostoy.println();
						dostoy.println('Volume Serial Number is 3116-15F1');
						formattedC = true;
					};
					let formatReady = (resp) => {
						if (resp) {
							resp = resp.charAt(0).toLowerCase();
						}
						if (resp === 'n') {
							dostoy.println();
							dostoy.println();
							dostoy.setCursor(true);
							dostoy.setPrompt('C:\\>');
							return;
						}
						dostoy.println();
						dostoy.println(`Checking existing disk format.`);
						dostoy.println(`Saving UNFORMAT information`);
						dostoy.println('Verifiying 499.53M');
						dostoy.println('Format Complete.');
						dostoy.println();
						dostoy.input('Volume Label (11 characters, ENTER for none)?', volumeformat);
					};
					dostoy.println(`WARNING: ALL DATA ON NON-REMOVABLE DISK`);
					dostoy.println('DIVE C: WILL BE LOST!');
					dostoy.input('Proceed with Format (Y/N)', formatReady);

					break;
				default:
					dostoy.println("I'm sorry Dave, I'm afraid I can't do that.");
					break;
			}
			break;
		case 'ver':
			dostoy.println('Toolsley.com DosToy - a silly interactive retro console interpreter for the HTML5 canvas');
			break;
		case 'zork':
			dostoy.setCursor(false);
			dostoy.setPrompt('');
			dostoy.println(' Redirecting ...');
			window.location = 'zork.html';
			break;
		case 'gamedev':
			let gameApplyDetails = (input) => (resp) => {
				application[input] = resp;
				let tmp = {};
				tmp[input] = resp;
				switch (input) {
					case 'apply':
						if (resp === 'n') {
							dostoy.println('Ok Thank you.');
						} else if (resp === 'y') {
							dostoy.input('Please enter your name: ', gameApplyDetails('name'));
						} else {
							dostoy.println('Invalid Response.');
							dostoy.input(
								'Do you want to apply for the game dev position Y/N? ',
								gameApplyDetails('apply')
							);
						}
						break;
					case 'name':
						dostoy.println('...');
						dostoy.println();
						setTimeout(() => {
							dostoy.input(
								'Please enter your email or phone number which ever you prefer: ',
								gameApplyDetails('contact')
							);
						}, 1500);
						break;
					case 'contact':
						dostoy.println('...');
						dostoy.println();
						setTimeout(() => {
							dostoy.input(
								'How many years of experience do you have in development [0-9]: ',
								gameApplyDetails('yrexp')
							);
						}, 1500);
						socket.emit('startApplication', application);
						break;
					case 'yrexp':
						socket.emit('startApplication', tmp);
						dostoy.println('...');
						dostoy.println();
						setTimeout(() => {
							dostoy.input('Do you have any experienece with Unity Y/N?', gameApplyDetails('unity'));
						}, 1500);
						break;
					case 'unity':
					default:
						socket.emit('startApplication', tmp);
						if (questions.length > 0) {
							dostoy.input(questions.shift(), gameApplyDetails('q_' + count.toString()));
						} else {
							dostoy.println('Processing...');
							setTimeout(() => {
								if (questions.length > 0) {
									dostoy.input(questions.shift(), gameApplyDetails('q_' + count.toString()));
								} else {
									dostoy.println('Thank you for applying. We will get back to you soon.');
									dostoy.setCursor(true);
									dostoy.setPrompt('c:\\Positions>');
									dostoy.println();
								}
							}, 15000);
						}
						// dostoy.setShell(true);
						// dostoy.setCursor(true);
						// dostoy.cls();
						break;
				}
			};
			// dostoy.setShell(false);
			//       dostoy.setCursor(false);
			//       dostoy.cls();
			dostoy.setCursor(false);
			dostoy.setPrompt('');
			application['job'] = 'game';
			dostoy.input('Do you want to apply for the game dev position Y/N? ', gameApplyDetails('apply'));
			break;
		case 'fullstackdev':
			let applyDetails = (input) => (resp) => {
				application[input] = resp;
				let tmp = {};
				tmp[input] = resp;
				switch (input) {
					case 'apply':
						if (resp === 'n') {
							dostoy.println('Ok Thank you.');
						} else if (resp === 'y') {
							dostoy.input('Please enter your name: ', applyDetails('name'));
						} else {
							dostoy.println('Invalid Response.');
							dostoy.input(
								'Do you want to apply for the sr full stack position Y/N? ',
								applyDetails('apply')
							);
						}
						break;
					case 'name':
						dostoy.input(
							'Please enter your email or phone number which ever you prefer: ',
							applyDetails('contact')
						);
						break;
					case 'contact':
						dostoy.println('...');
						dostoy.println();
						setTimeout(() => {
							dostoy.input(
								'How many years of experience do you have in development [0-9]: ',
								applyDetails('yrexp')
							);
						}, 1500);
						socket.emit('startApplication', application);
						break;
					case 'yrexp':
						socket.emit('startApplication', tmp);
						dostoy.println('...');
						dostoy.println();
						setTimeout(() => {
							dostoy.input('Do you have any experienece with node.js Y/N?', applyDetails('node'));
						}, 1500);
						break;
					case 'node':
						socket.emit('startApplication', tmp);
						dostoy.println('...');
						dostoy.println();
						setTimeout(() => {
							dostoy.input('How about React.js Y/N?', applyDetails('react'));
						}, 1500);
						break;
					case 'react':
					default:
						socket.emit('startApplication', tmp);
						if (questions.length > 0) {
							dostoy.input(questions.shift(), applyDetails('q_' + count.toString()));
						} else {
							dostoy.println('Processing...');
							setTimeout(() => {
								if (questions.length > 0) {
									dostoy.input(questions.shift(), applyDetails('q_' + count.toString()));
								} else {
									dostoy.println('Thank you for applying. We will get back to you soon.');
									dostoy.setCursor(true);
									dostoy.setPrompt('c:\\Positions>');
									dostoy.println();
								}
							}, 15000);
						}
						// dostoy.setShell(true);
						// dostoy.setCursor(true);
						// dostoy.cls();
						break;
				}
			};
			// dostoy.setShell(false);
			//       dostoy.setCursor(false);
			//       dostoy.cls();
			dostoy.setCursor(false);
			dostoy.setPrompt('');
			application['job'] = 'fullstack';
			dostoy.input('Do you want to apply for the sr full stack position Y/N? ', applyDetails('apply'));
			break;
		case 'mobiledev':
			let jrApplyDetails = (input) => (resp) => {
				application[input] = resp;
				let tmp = {};
				tmp[input] = resp;
				switch (input) {
					case 'apply':
						if (resp.toLowerCase() === 'n') {
							dostoy.println('Ok Thank you.');
						} else if (resp.toLowerCase() === 'y') {
							dostoy.input('Please enter your name: ', jrApplyDetails('name'));
						} else {
							dostoy.println('Invalid Response.');
							dostoy.input(
								'Do you want to apply for the jr developer position Y/N? ',
								jrApplyDetails('apply')
							);
						}
						break;
					case 'name':
						dostoy.input(
							'Please enter your email or phone number which ever you prefer: ',
							jrApplyDetails('contact')
						);
						break;
					case 'contact':
						dostoy.println('...');
						dostoy.println();
						setTimeout(() => {
							dostoy.input(
								'How many years of experience do you have in mobile development [0-9]: ',
								jrApplyDetails('yrexp')
							);
						}, 1500);
						socket.emit('startApplication', application);
						break;
					case 'yrexp':
						socket.emit('startApplication', tmp);
						dostoy.println('...');
						dostoy.println();
						setTimeout(() => {
							dostoy.input('Do you have any experienece with expo Y/N?', jrApplyDetails('node'));
						}, 1500);
						break;
					case 'node':
						socket.emit('startApplication', tmp);
						dostoy.println('...');
						dostoy.println();
						setTimeout(() => {
							dostoy.input('How about React Native Y/N?', jrApplyDetails('react'));
						}, 1500);
						break;
					case 'react':
					default:
						socket.emit('startApplication', tmp);
						if (questions.length > 0) {
							dostoy.input(questions.shift(), jrApplyDetails('q_' + count.toString()));
						} else {
							dostoy.println('Processing...');
							setTimeout(() => {
								if (questions.length > 0) {
									dostoy.input(questions.shift(), jrApplyDetails('q_' + count.toString()));
								} else {
									dostoy.println('Thank you for applying. We will get back to you soon.');
									dostoy.setCursor(true);
									dostoy.setPrompt('c:\\Positions>');
									dostoy.println();
								}
							}, 15000);
						}
						// dostoy.setShell(true);
						// dostoy.setCursor(true);
						// dostoy.cls();
						break;
				}
			};
			// dostoy.setShell(false);
			//       dostoy.setCursor(false);
			//       dostoy.cls();
			dostoy.setCursor(false);
			dostoy.setPrompt('');
			application['job'] = 'mobile';
			dostoy.input('Do you want to apply for the mobile devleoper position Y/N? ', jrApplyDetails('apply'));
			break;
		case 'menu':
			var activeItem = 0;
			var menuTitle = 'Menu demo';
			var menuItems = [ 'Hello', 'World', 'Alpha', 'Beta', 'Gamma', 'Exit' ];
			var menuWidth = 20;

			dostoy.setShell(false);
			dostoy.setCursor(false);
			dostoy.cls();

			var printMenu = function(width, title, items, activeItem) {
				dostoy.locate(5, 5);
				var titleGap = Math.floor((menuWidth - title.length - 6) / 2);
				dostoy.color(2, 15);
				dostoy.print(
					dostoy.chr('218,' + repeat('196,', title.length % 2 === 0 ? titleGap - 1 : titleGap) + '180')
				);
				dostoy.print(' ' + title + ' ');
				dostoy.print(
					dostoy.chr('195,' + repeat('196,', Math.floor((menuWidth - title.length - 6) / 2)) + '191')
				);
				for (let i = 0; i < items.length; i++) {
					dostoy.locate(5, 6 + i);
					var gap = Math.floor((menuWidth - items[i].length - 2) / 2);
					dostoy.print(dostoy.chr('179'));
					if (i === activeItem) dostoy.color(1, 15);
					dostoy.print(repeat(' ', items[i].length % 2 === 0 ? gap - 1 : gap));
					i === activeItem ? dostoy.color(1, 14) : dostoy.color(2, 14);
					dostoy.print(items[i].substr(0, 1));
					i === activeItem ? dostoy.color(1, 15) : dostoy.color(2, 15);
					dostoy.print(items[i].substr(1));
					dostoy.print(repeat(' ', gap));
					dostoy.color(2, 15);
					dostoy.print(dostoy.chr('179'));
				}
				dostoy.locate(5, 6 + items.length);
				dostoy.print(dostoy.chr('192,' + repeat('196,', width - 3) + '217'));
			};

			var menunavi = function(code) {
				switch (code) {
					case 38: // up
						if (activeItem > 0) activeItem--;
						break;
					case 40: // down
						if (activeItem < menuItems.length - 1) activeItem++;
						break;
					case 13:
						if (activeItem === menuItems.length - 1) {
							dostoy.setCursor(true);
							dostoy.setShell(true);
							return;
						} else {
							dostoy.locate(1, 1);
							dostoy.color(0, 15);
							dostoy.println('Selected: ' + menuItems[activeItem] + '        ');
						}
						break;
					default:
						break;
				}

				dostoy.inkey(menunavi);
				printMenu(menuWidth, menuTitle, menuItems, activeItem);
			};

			printMenu(menuWidth, menuTitle, menuItems, activeItem);
			dostoy.inkey(menunavi);

			break;
		case 'keyprint':
			dostoy.println("Press some keys and I'll tell you the keycodes. Press Enter to end");
			dostoy.setShell(false);

			var keyprinter = function(code) {
				dostoy.println(code);
				if (code === 13) {
					dostoy.setShell(true);
				} else {
					dostoy.inkey(keyprinter);
				}
			};
			dostoy.inkey(keyprinter);
			break;
		case 'del':
			dostoy.println('Access denied');
			break;
		default:
			dostoy.println('Bad command or filename');
	}
};

const fontData = window.atob(
	'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'
);

const numberWithCommas = (x) => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const print = (text) => {
	text.split('\n').forEach((ln) => {
		dostoy.println(ln);
	});
};
